import * as E360 from '@expert360';

export const statusText = {
  [E360.ProjectStateV2.New]: 'New',
  [E360.ProjectStateV2.Open]: 'Open',
  [E360.ProjectStateV2.Paused]: 'Applications Paused',
  [E360.ProjectStateV2.OnHold]: 'On Hold',
  [E360.ProjectStateV2.Draft]: 'Draft',
  [E360.ProjectStateV2.Hired]: 'Contract Awarded',
  [E360.ProjectStateV2.Cancelled]: 'Cancelled',
  [E360.ProjectStateV2.Closed]: 'Completed',
  UNLISTED: 'Direct Engagement',
  INVITATION_ONLY: 'Invitation-only',
};

export const isUnlisted = (project: Partial<E360.ProjectV2>) =>
  project && project.unlisted;

export const isInvitationOnly = (project: Partial<E360.ProjectV2>) =>
  project &&
  project.privacy === E360.ProjectPrivacyV2.Private &&
  (project.state === E360.ProjectStateV2.New ||
    project.state === E360.ProjectStateV2.Open) &&
  !project.unlisted;

export const statusTextForAudience = (
  project: Partial<E360.ProjectV2>
): string | null => {
  if (!project || !project.state) return null;
  if (isUnlisted(project)) return statusText.UNLISTED;
  if (isInvitationOnly(project) && project.isSharedWithPrivateCloud)
    return null;
  if (isInvitationOnly(project)) return statusText.INVITATION_ONLY;
  return statusText[project.state] || null;
};
